import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Block, Preloader } from 'framework7-react'

import classes from './styles.module.css'

class Loading extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  };

  /**
   * @inheritdoc
   */
  static get defaultProps() {
    return {
      size: 21,
      height: 50
    };
  };

  render() {
    const { size, height } = this.props;

    return (
      <Block className={ classes.root } style={{ height }}>
        <Preloader size={ size } />
      </Block>
    );
  };
};

Loading.propTypes = {
  size: PropTypes.number,
  height: PropTypes.number
};

export default Loading;
